export const environment = {
  rootUrl: 'https://test-api.billnote.in',
  graphqlUri: 'https://test-api.billnote.in/api/v1/graphql',
  closingUri: 'https://test-api.billnote.in/api/v1/closing_report',
  localGraphqlUri: 'http://{ip}:3000/api/v1/graphql',
  localPrintUri: 'http://127.0.0.1:3000/api/v1/print',
  localCashDrawerUri: 'http://127.0.0.1:3000/api/v1/cash-drawer',
  production: true,

  firebaseConfig : {
    apiKey: "AIzaSyAkNOOH-FRF91YnqYHfoMVcqaEizCzyHhc",
    authDomain: "billnote-99846.firebaseapp.com",
    projectId: "billnote-99846",
    storageBucket: "billnote-99846.appspot.com",
    messagingSenderId: "392355118903",
    appId: "1:392355118903:web:bb0569921280e493f424b2",
    measurementId: "G-FKPR9PEBPX"
  },
  vapidKey: "BNxoBqOT_Zz8nxLOfo1SGKi70DWsC98oEqQpFkEO6sEqX3iunlFrNRcOAflwMPH0IiJ-yCpUQRnOW0QYxKTSDIM"
};
